/**
 * @file Helper for comments
 */

import { Comment } from '@@/types'

// Check created_at to differentiate between a pending comment and one that has been returned from the server after creation.
// We don't want to pre-emptively show awaiting approval when none of the timestamps exist yet.
const getIsCommentAwaitingApproval = (comment: Comment) => !!comment.created_at && !comment.published_at

export { getIsCommentAwaitingApproval }
